import React from 'react';
import PropTypes from 'prop-types';

import Link from '../Link';

import { StyledImage } from './styles';

const LinkWithImage = ({
  linkURL,
  imageSrc,
  imageSharp,
  altText,
  className,
  children,
}) => {
  return (
    <Link to={linkURL} ariaLabel={altText}>
      {children && children}
      <StyledImage
        src={imageSrc}
        alt={altText}
        imageSharp={imageSharp}
        className={className}
      />
    </Link>
  );
};

LinkWithImage.propTypes = {
  linkURL: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  altText: PropTypes.string,
  imageSharp: PropTypes.object,
  children: PropTypes.element,
};

LinkWithImage.defaultProps = {
  altText: '',
  imageSharp: {},
  imageSrc: '',
  children: null,
};

export default LinkWithImage;
